import React from "react";
import createReactClass from 'create-react-class';
import {connect} from 'react-redux';
import {Tabs, Tab} from 'react-bootstrap';
import {AccountModes, JoinSteps, JoinModes, FetchingTypes} from "../../common/constants";
import {setAccountMode, changeSubscription} from "../../actions/account/accountActions";
import {getSignupData, clearSignupData, setInvalidOptionSchedulesMessage, isValidOptionScheduleMessage} from "../../actions/join/joinActions";
import {getJoinSelectedItems, getNextDeliveryDate} from "../../common/basket";
import {checkIsDirty, setDirty} from '../../actions/common/commonActions';
import ModalPopup from "../../components/common/ModalPopup";
import AccountNavigationHeader from "../../components/account/AccountNavigationHeader";
import SelectionTabs from "../../components/common/SelectionTabs";
import SelectionPane from "../../components/common/SelectionPane";
import {isFetching} from "../../actions/common/fetchingActions";
import JoinSharesOptionsStep from "../join/JoinSharesOptionsStep";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {translate} from '../../i18n/translate.js';

const AccountChangeSubscription = createReactClass( {
    getInitialState() {
        this.nextDeliveryDate = this.props.nextDeliveryDate;
        return {
            showNoSharesDialog:false,
            closeScheduledDistributionInProcessDialog:false
        }
    },

    componentWillMount() {
        if (this.props.shouldReloadData)
            this.props.getSignupData();
    },

    onCancel() {
        this.props.checkIsDirty(!this.props.isPreview, function() {
            this.props.cancel();
        }.bind(this));
    },
    onSave() {
        if(this.props.activeWebOrderKey && this.props.nextDeliveryDate !== this.nextDeliveryDate) {
            this.setState({showScheduledDistributionInProcessDialog: true});
            return;
        }
        if (this.props.allowChangeFreeOptions){
            const selectedOptions = getJoinSelectedItems(this.props.sharesData.options, {});
            const freeItems = selectedOptions.items.filter(item => item.price === 0);
            if (freeItems.length > 1){
                this.props.setInvalidOptionSchedulesDialog("You cannot select more than one free item.");
                return;
            }
        }
        if(this.props.syncOptionSchedules) {
            const storeAccessShare = this.props.summary.seasons && this.props.summary.seasons[0].storeAccessShare;
            const message = isValidOptionScheduleMessage(this.props.sharesData, this.props.signupData.schedules, storeAccessShare);
            if(message) {
                this.props.setInvalidOptionSchedulesDialog(message);
                return;
            }
        }
        const currentShares = getJoinSelectedItems(this.props.summary.shareItems, {});
        const selectedShares = getJoinSelectedItems(this.props.sharesData.shares, {});
        const currentCredits = currentShares.items.reduce((sum, item) => sum + (item.unit === 'credits' ? item.quantity * item.unitQuantity : 0), 0);
        const selectedCredits = selectedShares.items.reduce((sum, item) => sum + (item.unit === 'credits' ? item.quantity * item.unitQuantity : 0), 0);
        if (selectedCredits < currentCredits && this.props.activeWebOrderKey) {
            this.props.setInvalidOptionSchedulesDialog('You can’t change subscription to smaller size while having a web order in place. Please contact the farm admin for further assistance.');
            return;
        }
        if (selectedShares.items.length > 0) {
            this.props.save();
        } else {
            this.setState({showNoSharesDialog: true});
        }
    },
    closeDialog() {
        this.setState({showNoSharesDialog : false});
    },
    closeScheduledDistributionInProcessDialog() {
        this.setState({showScheduledDistributionInProcessDialog : false});
    },

    getButtons(allowSave) {
        return(
            {
                left: {
                    label: translate("CANCEL"),
                    onClick: this.onCancel
                },
                right: {
                    label: translate("SAVE"),
                    onClick: this.onSave,
                    disabled: !allowSave || this.props.isPreview,
                    className: this.props.isUpdating?" loading":""
                }
            });
    },
    renderScreen() {
        if (this.props.allowChangeFreeOptions){
            return (
                <div className="account-change-subscription-no-tabs">
                    <JoinSharesOptionsStep step={JoinSteps.OPTIONS} flow={JoinModes.CHANGE}/>
                </div>
            );
        }
        if (!this.props.hasOptions)
            return (
                <div className="account-change-subscription-no-tabs">
                    <JoinSharesOptionsStep step={JoinSteps.SHARES} flow={JoinModes.CHANGE}/>
                </div>
            );
        if (this.props.clientViewPort.isXs)
            return (
                <Tabs defaultEventKey="shares" className="account-change-subscription-tabs">
                    <Tab title={translate("Shares")} eventKey="shares">
                        <JoinSharesOptionsStep step={JoinSteps.SHARES} flow={JoinModes.CHANGE}/>
                    </Tab>
                    <Tab title="Options" eventKey="options">
                        <JoinSharesOptionsStep step={JoinSteps.OPTIONS} flow={JoinModes.CHANGE}/>
                    </Tab>
                </Tabs>
            );
        return (
            <SelectionTabs disableCheckDirty={true}>
                <SelectionPane label={translate("Shares")} styleClass="tabs-line-separator" >
                    <JoinSharesOptionsStep step={JoinSteps.SHARES} flow={JoinModes.CHANGE}/>
                </SelectionPane>
                <SelectionPane label="Options" styleClass="tabs-line-separator" >
                    <JoinSharesOptionsStep step={JoinSteps.OPTIONS} flow={JoinModes.CHANGE}/>
                </SelectionPane>
            </SelectionTabs>
        );
    },
    closeInvalidOptionSchedulesDialog() {
        this.props.setInvalidOptionSchedulesDialog(undefined);
    },
    render() {
        if(this.props.isFetching) {
            return <LoadingAnimation/>;
        }
        const buttons = this.getButtons(this.props.isChanged);

        return (
            <fieldset disabled={this.props.isUpdating}>
                <AccountNavigationHeader buttons={buttons} title={this.props.allowChangeFreeOptions ? translate("Select Free Item") : translate("Change Subscription")}/>
                {this.renderScreen()}
                {this.props.mode == AccountModes.CHANGE_SUBSCRIPTION_THANKYOU ?
                    <ModalPopup
                        title="_thankYouChangeSubscriptionTitle"
                        message="_thankYouChangeSubscriptionBody"
                        middle={{text:'Close', callback:this.props.backFromThankYou}}/>
                    : undefined
                }
                {this.state.showNoSharesDialog ?
                    <ModalPopup
                        title="selectShare"
                        middle={{text:'Continue', callback:this.closeDialog}}/>
                    : undefined
                }
                {this.state.showScheduledDistributionInProcessDialog ?
                    <ModalPopup
                        message={translate("_ScheduledDistributionInProcess")}
                        middle={{text: 'Close', callback: this.closeScheduledDistributionInProcessDialog}}/>
                    : undefined
                }
                {this.props.invalidOptionScheduleMessage ?
                    <ModalPopup
                        message={this.props.invalidOptionScheduleMessage}
                        middle={{text: 'Close', callback: this.closeInvalidOptionSchedulesDialog}}/>
                    : undefined
                }
            </fieldset>
        );
    }
});

const mapStateToProps = (state) =>  {
    const summary = state.summary || {};
    const signupData = (state.signupData || {});
    let nextDeliveryDate;
    const selectedItems = signupData.sharesData?getJoinSelectedItems(signupData.sharesData.shares, signupData.sharesData.options):{};
    const items = selectedItems.items;
    const schedules = signupData.schedules || {};
    const nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
    if(nextDeliveryDates) {
        nextDeliveryDate = getNextDeliveryDate(summary.pickupSite, items, schedules, nextDeliveryDates);
    } else {
        nextDeliveryDate = summary.nextDeliveryDate;
    }

    return {
        clientViewPort: (state.clientViewPort || {}),
        mode: state.account.mode,
        isFetching: isFetching(state, FetchingTypes.LOAD_SIGNUP_DATA)
                || isFetching(state, FetchingTypes.LOAD_SIGNUP_SHARES),
        isPreview: (state.staticData || {}).isPreview,
        shouldReloadData: !signupData.data,
        deliveryDay: (summary.pickupSite || {}).deliveryDays,
        isChanged: state.orderStatus.isChanged,
        hasOptions: (signupData.data || {}).hasOptions,
        sharesData: signupData.sharesData,
        isUpdating: isFetching(state, FetchingTypes.CHANGE_SUBSCRIPTION),
        nextDeliveryDate: nextDeliveryDate,
        activeWebOrderKey: summary.activeWebOrderKey,
        summary: summary,
        syncOptionSchedules: state.staticData.syncOptionSchedules,
        invalidOptionScheduleMessage: signupData.invalidOptionScheduleMessage,
        signupData: signupData,
        allowChangeFreeOptions: state.staticData.allowChangeFreeOptions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        checkIsDirty: (check, onLeaveCallBack) => {
            if (check)
                dispatch(checkIsDirty(onLeaveCallBack));
            else
                onLeaveCallBack();
        },
        getSignupData: () => {
            dispatch(getSignupData(JoinModes.CHANGE));
        },
        cancel: () => {
            dispatch(clearSignupData());
            dispatch(setDirty(false));
            dispatch(setAccountMode(AccountModes.VIEW));
        },
        save: () => {
            dispatch(changeSubscription());
            dispatch(setDirty(false));
        },
        backFromThankYou: () => {
            window.location.reload();
        },
        setInvalidOptionSchedulesDialog: (message) => {
            dispatch(setInvalidOptionSchedulesMessage(message));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountChangeSubscription);



// WEBPACK FOOTER //
// ./src/containers/account/AccountChangeSubscription.js